var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunicationsQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#999;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 34.664)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M68.93,202.887a1.992,1.992,0,0,0-1.992,1.992v13.746a9.972,9.972,0,0,1-9.961,9.961H35.467a1.992,1.992,0,0,0-1.992,1.991l0,3.961-4.755-4.755a1.993,1.993,0,0,0-1.827-1.2H13.945a9.972,9.972,0,0,1-9.961-9.961v-30.68a9.972,9.972,0,0,1,9.961-9.961H34.066a1.992,1.992,0,0,0,0-3.984H13.945A13.961,13.961,0,0,0,0,187.945v30.68A13.961,13.961,0,0,0,13.945,232.57H25.87l8.182,8.182a1.992,1.992,0,0,0,3.4-1.407l0-6.775H56.977a13.961,13.961,0,0,0,13.945-13.945V204.879A1.992,1.992,0,0,0,68.93,202.887Z",
    transform: "translate(0 -174)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.047)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M230,0h-5.042a28.956,28.956,0,1,0,0,57.911H230a29.011,29.011,0,0,0,7.349-.942l7.448,7.444A1.992,1.992,0,0,0,248.2,63V51.478a29.232,29.232,0,0,0,7.611-9.384,28.644,28.644,0,0,0,3.146-13.139A28.988,28.988,0,0,0,230,0ZM245,48.915a1.993,1.993,0,0,0-.793,1.591V58.2l-4.875-4.872a1.991,1.991,0,0,0-1.993-.5,24.978,24.978,0,0,1-7.345,1.1h-5.042a24.971,24.971,0,1,1,0-49.943H230A24.972,24.972,0,0,1,245,48.915Z",
    transform: "translate(-196)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.647 13.958)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M331.31,77.9a8.454,8.454,0,0,0-7.82-7.82,8.369,8.369,0,0,0-6.348,2.247,8.464,8.464,0,0,0-2.68,6.167,1.992,1.992,0,0,0,3.984,0,4.451,4.451,0,0,1,4.77-4.439,4.451,4.451,0,0,1,.658,8.781,3.77,3.77,0,0,0-2.97,3.7v4.786a1.992,1.992,0,1,0,3.984,0V86.695A8.391,8.391,0,0,0,331.31,77.9Z",
    transform: "translate(-314.462 -70.063)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.089 41.105)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M350.2,206.914a1.994,1.994,0,1,0,.584,1.408A2.007,2.007,0,0,0,350.2,206.914Z",
    transform: "translate(-346.8 -206.33)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.758 61.758)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M98.027,310H55.992a1.992,1.992,0,0,0,0,3.984H98.027a1.992,1.992,0,1,0,0-3.984Z",
    transform: "translate(-54 -310)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.793 72.914)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M268.4,366.584a1.991,1.991,0,1,0,.584,1.408A2.006,2.006,0,0,0,268.4,366.584Z",
    transform: "translate(-265 -366)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.758 72.914)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M90.191,366h-34.2a1.992,1.992,0,0,0,0,3.984h34.2a1.992,1.992,0,0,0,0-3.984Z",
    transform: "translate(-54 -366)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.758 50.602)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.078,254H55.992a1.992,1.992,0,0,0,0,3.984H85.078a1.992,1.992,0,0,0,0-3.984Z",
    transform: "translate(-54 -254)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationsQuestion);
export default __webpack_public_path__ + "static/media/communications-question.b1c7097118b56eb6687fd16d3031ec70.svg";
export { ForwardRef as ReactComponent };